// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"Checkbox_inputContainer__2ZEuo","label":"Checkbox_label__2gCWC","inputWrap":"Checkbox_inputWrap__UZMwr","checkmark":"Checkbox_checkmark__2MXCy"};